import type { ObjectsImportResult } from '../../api';

const n = (v: number): string => v.toLocaleString('de-DE');

/**
 * Building types that have example objects but no benchmark: the popup of a
 * benchmark and the filter never reach them, so the catalog offers them on
 * their own (AP-129) - e.g. the types of a newly read volume.
 */
export function typesWithoutBenchmarks(
  objectTypes: readonly { buildingType: string; objects: number }[],
  benchmarkTypes: readonly (string | null)[],
): { buildingType: string; objects: number }[] {
  const known = new Set(benchmarkTypes.filter((t): t is string => !!t));
  return objectTypes.filter((t) => !known.has(t.buildingType));
}

/** What reading example objects in did, in one line; orange when something is missing or was left out. */
export function objectsImportMessage(r: ObjectsImportResult): { color: 'green' | 'orange'; text: string } {
  const parts = [`${n(r.objects)} Objekte eingelesen, ${n(r.withImage)} mit Foto`];
  if (r.missingImages) parts.push(`${n(r.missingImages)} Fotos fehlen im Medienordner`);
  if (r.conflicts.length) {
    const byEdition = new Map<string, string[]>();
    for (const c of r.conflicts) byEdition.set(c.edition, [...(byEdition.get(c.edition) ?? []), c.objectNo]);
    const where = [...byEdition].map(([edition, nos]) => `„${edition}“ (${nos.slice(0, 5).join(', ')}${nos.length > 5 ? ` und ${n(nos.length - 5)} weitere` : ''})`);
    parts.push(`${n(r.conflicts.length)} Objekte nicht eingelesen: Nummer bereits in Ausgabe ${where.join(', ')}`);
  }
  if (r.duplicates) parts.push(`${n(r.duplicates)} Nummern doppelt in der Datei, jeweils die erste eingelesen`);
  const problem = r.missingImages > 0 || r.conflicts.length > 0 || r.duplicates > 0;
  return { color: problem ? 'orange' : 'green', text: `${parts.join('; ')}.` };
}
